<template>
  <div class="custom-card page-wrapper">
    <ControlPagoDocentePorEmpresaTab />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ControlPagoDocentePorEmpresaTab from '../components/ControlPagoDocentePorEmpresaTab.vue';

export default {
  name: 'ControlPagoDocentePorEmpresaPage',
  components: {
    ControlPagoDocentePorEmpresaTab,
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 16px;
  margin: 0px 8px 0px 8px;
}

.page-wrapper {
  background-color: #fafbfc;
  border-radius: 12px;
}
</style>

